// extracted by mini-css-extract-plugin
export default {"DestinationInfoCards":"DestinationInfoCards_DestinationInfoCards__MjJhO","DestinationInfoCards--reserveSpace":"DestinationInfoCards_DestinationInfoCards--reserveSpace__YmZlM"};